import { useCurrentUserQuery } from "@graphql/users/users.g";

import { User } from "@design-system/User/User";

export const CurrentUser = () => {
  const currentUserQuery = useCurrentUserQuery();

  const user = currentUserQuery.data?.currentUser;

  return (
    <User
      name={user?.name}
      email={user?.email}
      isLoading={currentUserQuery.isLoading}
    />
  );
};
